
function PipelineCenter() {
  return (
    ""
  );
}

export default PipelineCenter;
